export const USERS_LANDING_URL: string | undefined = process.env['NX_USERS_LANDING_URL'];
const LEGACY_LANDING_HOSTNAMES = ['local.quadminds.com', 'testing.quadminds.com', 'platform.quadminds.com'];

export const getUsersLandingUrl = (): string => {
    if (USERS_LANDING_URL) {
        return USERS_LANDING_URL;
    }
    if (LEGACY_LANDING_HOSTNAMES.includes(globalThis.location.hostname)) {
        return `${globalThis.location.origin}/apps/landing`;
    }
    return `${globalThis.location.origin}/apps/mindy-landing`;
};
export const AUTH_API_URL: string | undefined = process.env['NX_AUTH_API_URL'];
export const AUTH_MINDY_API_URL: string | undefined = process.env['NX_AUTH_MINDY_API_URL'];
export const AGENTS_API_URL: string | undefined = process.env['NX_AGENTS_API_URL'];
export const NODE_ENV: string | undefined = process.env['NODE_ENV'];
export const MAIL_API_URL: string | undefined = process.env['NX_MAIL_API_URL'];
export const FEEDBACK_MAIL: string | undefined = process.env['NX_FEEDBACK_MAIL'];
export const MINDY_VERSION: string | undefined = process.env['NX_MINDY_VERSION'];
export const CLIENT_ID: string | undefined = process.env['NX_GOOGLE_CLIENT_ID'];
export const GOOGLE_API_KEY: string | undefined = process.env['NX_GOOGLE_PICKER_API_KEY'];
export const PLATFORM_URL: string | undefined = process.env['NX_PLATFORM_URL'];
export const INTEGRATION_API_URL: string | undefined = process.env['NX_INTEGRATION_API_URL'];
export const MINDY_APP_URL: string | undefined = process.env['NX_MINDY_APP_URL'];
export const STORK_AUTH_API_URL: string | undefined = process.env['NX_STORK_AUTH_API_URL'];
export const STORK_USERS_API_URL: string | undefined = process.env['NX_STORK_USERS_API_URL'];
